import { views } from 'enums/menu-enums';

export const setTableData = (table, activeListings, openOrders, completedOrders) => {
  const tableData = {
    data: [],
    total: 0,
    current: 1,
  };

  if (table === views.activeListings) {
    tableData.data = activeListings.products;
    tableData.total = activeListings.metadata ? activeListings.metadata.totalCount : 0;
    tableData.current = activeListings.metadata ? activeListings.metadata.currentPage : 1;
  } else if (table === views.open) {
    tableData.data = openOrders.orders;
    tableData.total = openOrders.metadata ? openOrders.metadata.totalCount : 0;
    tableData.current = openOrders.metadata ? openOrders.metadata.currentPage : 1;
  } else if (table === views.completed) {
    tableData.data = completedOrders.orders;
    tableData.total = completedOrders.metadata ? completedOrders.metadata.totalCount : 0;
    tableData.current = completedOrders.metadata ? completedOrders.metadata.currentPage : 1;
  }

  return tableData;
};

export const tableItemsLabel = (total, pageSize, current, table) => {
  const tableLabel = {
    start: 0,
    end: 0,
    total: total,
  };
  const itemType = table === views.activeListings ? 'Listings' : 'Orders';

  tableLabel.start = current * pageSize - (pageSize - 1);
  tableLabel.end = Math.min(tableLabel.start + pageSize - 1, total);

  return `Showing ${tableLabel.start} - ${tableLabel.end} of ${total} ${itemType}`;
};

export const appendSizeUnitAndSingleGender = (pt, tableData) => {
  const data = tableData;
  data.forEach((t) => {
    t.sizeUnit = pt.sizeUnit.toUpperCase();
    t.singleGender = pt.singleGender;
  });
  return data;
};
